import { IMedia } from "src/model/unityObject";

const hasMediaBeenGeneratedByAi = (media: IMedia) =>
  !!(media.metadata && typeof media.metadata === "object" && media.metadata.initialPrompt);

export default hasMediaBeenGeneratedByAi;
